<template>
  <div class="checkout-page">
    <Header />

    <main class="checkout-page__body bg_gray pattern">
      <div class="checkout-page__toolbar">
        <button
          type="button"
          class="checkout-page__back"
          aria-label="Go back to table management"
          @click="goBack"
        >
          <i class="fas fa-arrow-left" aria-hidden="true"></i>
          Back
        </button>
      </div>

      <div class="container margin_60_40 checkout-page__container">
      <div class="row ">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
          <div class="box_booking_2">
            <div class="head">
              <div class="title text-center">
              
                  <div class="text-center" style="font-size:20px;font-weight:bold">
              Gnanams Hotel
                </div>
                  <div class="text-center" style="font-size:13px">
               299, 301 Clock Tower Rd, Jaffna
                </div>
                <div class="text-center" style="font-size:13px">
                 0212 220 630
                </div>
            
              </div>
            </div>
        
            <Loader v-if="loading" :loading="loading" :success="loginSuccess" />
            <div class="main back-white checkout-main" v-else>
              <h5 class="checkout-title">Order details</h5>
              <hr class="checkout-divider" />

              <dl class="checkout-meta">
                <div class="checkout-meta__pair">
                  <dt>Date</dt>
                  <dd>{{ Order.date | formatDate }}</dd>
                </div>
                <div class="checkout-meta__pair">
                  <dt>Time</dt>
                  <dd>{{ Order.date | formatTime }}</dd>
                </div>
                <div class="checkout-meta__pair">
                  <dt>Type</dt>
                  <dd class="checkout-meta__type">{{ orderTypeLabel }}</dd>
                </div>
                <div class="checkout-meta__pair">
                  <dt>Waiter</dt>
                  <dd>{{ (Order.waiter && Order.waiter.name) || '—' }}</dd>
                </div>
                <div class="checkout-meta__pair checkout-meta__pair--full">
                  <dt>Guest</dt>
                  <dd>{{ (Order.guest && Order.guest.name) || '—' }}</dd>
                </div>
              </dl>

              <hr class="checkout-divider" />
              <table class="checkout-table">
                <thead>
                  <tr>
                    <th class="checkout-table__item">Item</th>
                    <th>Unit</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Ingredients</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in Order.items" :key="index">
                
                  <td class="checkout-table__item text-left" v-if="item.dish">
                    <span class="checkout-table__dish-name">{{ item.dish.name }}</span>
                    <ul
                      v-if="item.ingredients && item.ingredients.length"
                      class="checkout-table__ingredients"
                    >
                      <li
                        v-for="(ingredient, ingIdx) in item.ingredients"
                        :key="ingIdx"
                      >
                        + {{ ingredient.name }} ({{ ingredient.amount }})
                      </li>
                    </ul>
                  </td>
                  <td class="text-left" v-else-if="item.product">
                    <span class="checkout-table__dish-name">{{ item.product.name }}</span>
                  </td>
                  <td v-else class="checkout-table__item">—</td>

                  <td class="text-center">
                    {{ (item.unit && item.unit.name) || '—' }}
                  </td>

                  <td class="text-right">{{ item.amount }}</td>

                  <td class="text-center">
                    <template v-if="item.adjust_quantity > 0">
                      {{ item.adjust_quantity }} g
                    </template>
                    <template v-else>{{ item.quantity }}</template>
                  </td>

                  <td class="text-right">
                    {{ item.ingredient_amount ? item.ingredient_amount : 0 }}
                  </td>
                  <td class="text-right">
                    {{ (item.amount * item.quantity).toFixed(2) }}
                  </td>
                </tr>
                </tbody>
              </table>

              <!-- <ul class="plan-features">
                <li
                  class="list-group-item d-flex justify-content-between align-items"
                  v-for="(item, index) in Order.items"
                  :key="index"
                >
                  <strong>{{ item.dish.name }} </strong>
                  <span class="badge badge-primary badge-pill">
                    {{ item.unit.name }}</span
                  >
                  <span class="badge badge-primary badge-pill">
                    {{ item.quantity }} * Rs .{{ item.amount }}
                  </span>
                </li>
              </ul> -->
              <hr class="checkout-divider" />






              <div class="checkout-totals">
                <div class="checkout-totals__row">
                  <span class="checkout-totals__label">Ingredients total</span>
                  <span class="checkout-totals__value">
                    {{ formatMoney(Order.ingredient_amount || 0) }}
                  </span>
                </div>



                <div class="checkout-totals__row">
                  <span class="checkout-totals__label">Food total</span>
                  <span class="checkout-totals__value">
                    {{ formatMoney(foodSubtotal) }}
                  </span>
                </div>
                <div class="checkout-totals__row checkout-totals__row--grand">
                  <span class="checkout-totals__label">Total</span>
                  <span class="checkout-totals__value">
                    {{ formatMoney(Order.total_amount || 0) }}
                  </span>
                </div>
              </div>









              <hr class="checkout-divider" />

              <a
                href="#"
                class="btn_1 full-width mb_5 checkout-complete-btn"
                @click.prevent="openSuspendModal()"
              >
                Complete order
              </a>
              <p class="checkout-footnote">
                No payment is taken on this step.
              </p>
            </div>
          </div>
          <!-- /box_booking -->
        </div>
        <div class="col-lg-3"></div>
        <!-- /col -->
      </div>
      <!-- /row -->
      </div>
      <!-- /container -->
    </main>

    <CModal
      Text="Checkout Bill"
      ref="SuspendModal"
      headerText="Check out bill"
      :width="480"
      submitText="Confirm"
      :hideButton="true"
    >
      <template v-slot:content>
        <div class="checkout-bill">
          <div class="checkout-bill__card">
            <div class="checkout-bill__row">
              <span class="checkout-bill__label">Customer</span>
              <span class="checkout-bill__value">
                {{ (Order.guest && Order.guest.name) || '—' }}
              </span>
            </div>

            <div class="checkout-bill__row checkout-bill__row--with-action">
              <div class="checkout-bill__row-main">
                <span class="checkout-bill__label">Total amount</span>
                <span class="checkout-bill__value">
                  {{ formatMoney(Order.total_amount || 0) }}
                </span>
              </div>
              <label class="checkout-bill__toggle">
                <input v-model="istotaldiscount" type="checkbox" />
                <span>Discount</span>
              </label>
            </div>
            <div v-if="istotaldiscount" class="checkout-bill__fields">
              <input
                v-model.number="total_discount"
                type="number"
                min="0"
                class="checkout-bill__input"
                placeholder="Discount amount"
                oninput="validity.valid||(value='');"
              />
              <input
                v-model="remarks"
                type="text"
                class="checkout-bill__input"
                placeholder="Discount note"
              />
            </div>

            <div
              v-if="Order.order_type != 'take_away' && servicecharge != null"
              class="checkout-bill__row checkout-bill__row--with-action"
            >
              <div class="checkout-bill__row-main">
                <span class="checkout-bill__label">
                  Service charge ({{ service_charge }}%)
                </span>
                <span class="checkout-bill__value">
                  {{ formatMoney(servicecharge) }}
                </span>
              </div>
              <label class="checkout-bill__toggle">
                <input v-model="isservicecharge" type="checkbox" />
                <span>Adjust</span>
              </label>
            </div>
            <div v-if="isservicecharge" class="checkout-bill__fields">
              <input
                v-model.number="service_discount"
                type="number"
                min="0"
                class="checkout-bill__input"
                placeholder="Service charge adjustment"
                oninput="validity.valid||(value='');"
              />
            </div>
          </div>

          <div class="checkout-bill__section">
            <label class="checkout-bill__label checkout-bill__label--block">
              Payment method
            </label>
            <select v-model="paymentType" class="checkout-bill__select">
              <option :value="null" disabled>Select method</option>
              <option value="Cash">Cash</option>
              <option value="Card">Card</option>
            </select>
            <template v-if="paymentType === 'Card'">
              <label class="checkout-bill__label checkout-bill__label--block">
                Bank name
              </label>
              <input
                v-model="bank"
                type="text"
                class="checkout-bill__input"
                placeholder="Enter bank name"
              />
            </template>
          </div>

          <div class="checkout-bill__payable">
            <span class="checkout-bill__payable-label">Payable amount</span>
            <span class="checkout-bill__payable-value">
              {{ formatMoney(payableAmount) }}
            </span>
          </div>

          <label class="checkout-bill__suspend-toggle">
            <input v-model="isSuspend" type="checkbox" />
            <span>Suspend — record partial payment</span>
          </label>

          <div v-if="isSuspend" class="checkout-bill__card checkout-bill__card--nested">
            <label class="checkout-bill__label checkout-bill__label--block">
              Partial amount
            </label>
            <input
              v-model.number="paymentAmount"
              type="number"
              min="0"
              class="checkout-bill__input"
              placeholder="Amount paid now"
              oninput="validity.valid||(value='');"
            />
            <label class="checkout-bill__label checkout-bill__label--block">
              Note <span class="checkout-bill__required">*</span>
            </label>
            <input
              v-model="note"
              type="text"
              class="checkout-bill__input"
              placeholder="Reason for suspend"
            />
          </div>

          <button
            v-if="isPaymentvisible"
            type="button"
            class="checkout-bill__submit"
            :disabled="Paymentdisable"
            @click="SubmitBill()"
          >
            {{ isSuspend ? 'Suspend bill' : 'Complete bill' }}
          </button>
        </div>
      </template>
    </CModal>
    <Bill
      :Order="Order"
      :paymentAmount="paymentAmount"
      v-show="completeBill"
      :paymentType="paymentType"
      ref="Bill"
    />
  </div>
</template>

<script>
import Bill from "../components/Share/Bill/index";
import { CustomModal as CModal } from "@/components/base/index.js";
import { Header } from "@/components/index.js";
import {
  ProductView,
  CheckboxList,
  ListingFilter,
} from "@/components/index.js";
import { Loader } from "@/components/base/index.js";
const iconComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
};

import VueRangeSlider from "vue-range-component";
import "vue-range-component/dist/vue-range-slider.css";
import axios from "@/plugins/axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      iconComponent: iconComponent,
      Order: new Object(),
      isSuspend: false,
      TableIdVisible: true,
      isPaymentvisible: true,
      Paymentdisable: false,
      paymentAmount: 0,
      note: null,
      loginSuccess: false,
      completeBill: false,
      loading: false,
      paymentType: null,
      bank: null,
      completeBill: false,
      loading: false,
      paymentType: null,
      bank: null,
      isservicecharge: false,
      servicecharge: null,
      grandtotal_amount: null,
      TableId: null,
      istotaldiscount: false,
      total_discount: 0,
      service_discount: 0,
      remarks: '',
    };
  },
  components: {
    Bill,
    Loader,
    CModal,
    Header,
  },
  methods: {
    goBack() {
      this.$router.push('/tables');
    },
    Oder() {
      if (this.isOrder) {
        this.UpdateOrder();
      } else {
        this.CreateOrder();
      }
    },
    async CreateOrder() {
      let Credentials = new Object();
      (Credentials.date = moment(new Date()).format("MM/DD/YYYY HH:MM")),
        (Credentials.order_type = this.selectedMethod.text),
        (Credentials.waiter = "Tharsan"),
        (Credentials.note = "note");
      if (this.selectedMethod.text == "Dine In") {
        Credentials.table_id = this.selected.key;
      }
      (Credentials.place_id = 1),
        (Credentials.guest = {
          name: "ffaaaffffffff",
          phone: "077826485",
          nic_number: "980361829V",
          email: "admin@gmail.com",
          address: "jaffma",
        });
      Credentials.items = [];
      this.OrderedFoods.map((food) => {
        let item = new Object();
        (item.dish_id = food.dishItem.id),
          (item.unit_id = food.unit.key),
          (item.quantity = food.count),
          (item.amount = food.amount),
          Credentials.items.push(item);
      });

      axios
        .post(`hms/orders`, Credentials)
        .then((res) => {
          this.loaded = true;
          this.OrderedFoods = [];
        })
        .catch((err) => {});
    },
   
    async CompleteOrder() {
      this.loading = true;
      let Credentials = new Object();
      Credentials.reference_number = "sample";
      Credentials.date_time = moment(new Date()).format("MM/DD/YYYY HH:MM");
      Credentials.payment_type = this.paymentType;
      Credentials.descount =
        parseFloat(this.service_discount) + parseFloat(this.total_discount);
      if (this.Order.order_type != "take_away") {
        Credentials.service_charge = (
          (parseFloat(this.Order.total_amount) *
            parseFloat(this.service_charge)) /
          100
        ).toFixed(0);
      }
      Credentials.remarks = this.remarks;
      if (this.paymentType == "Card") {
        Credentials.card_bank = this.bank;
      }

      if (this.isSuspend) {
        Credentials.amount = this.paymentAmount;
        Credentials.remarks = this.note;
      } else {
        Credentials.amount = this.payableAmount;
      }
      Credentials.remarks = null;


this.Paymentdisable= true;
this.isPaymentvisible= false;
      //    setTimeout(() => {
      //     this.Paymentdisable = true;
      // }, 2000);
      axios
        .post(`hms/web/orders/${this.Order.id}/payments`, Credentials)
        .then((res) => {
          this.loginSuccess = true;
          this.completeBill = true;
          let promise = this.GetOrder();
          promise.then((res) => {
            this.TableId = this.$route.params.id;
            this.$store.commit("orders/AddOrderTableDetails", this.TableId);
            this.$store.commit(
              "orders/AddOrderTableDetailsVisible",
              this.TableIdVisible
            );
            this.$refs.Bill.print();
            this.$router.push("/");
            this.OrderedFoods = [];
          });
        })
        .catch((err) => {
             setTimeout(() => {
          this.Paymentdisable= true;
this.isPaymentvisible= true;
      }, 2000);
        });
    },

    SubmitBill() {
      if (!this.paymentType) {
        this.$fire({
          title: "Error",
          text: "Please Select a Payment Type",
          type: "error",
          timer: 3000,
        }).then((r) => {});
      } else if (this.paymentType == "Card" && !this.bank) {
        this.$fire({
          title: "Error",
          text: "Please Enter the Bank Name",
          type: "error",
          timer: 3000,
        }).then((r) => {});
      } else if (this.isSuspend && !this.note) {
        this.$fire({
          title: "Error",
          text: "Please Enter the Note to suspend",
          type: "error",
          timer: 3000,
        }).then((r) => {});
      } else {
        this.CompleteOrder();
      }
    },

    GetOrder() {
      return new Promise((resolve, reject) => {
        let id = this.$route.params.id;
        axios
          .get(`hms/web/orders/${id}`)
          .then((res) => {
            //
            this.Order = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    openSuspendModal() {
      this.servicecharge =
        (this.Order.total_amount * this.service_charge) / 100;
      this.$refs.SuspendModal.show();
    },
    formatMoney(amount) {
      const n = parseFloat(amount);
      return Number.isFinite(n) ? n.toFixed(2) : '0.00';
    },
    orderTypeLabelFrom(type) {
      const map = {
        dine_in: 'Dine in',
        take_away: 'Take away',
        service_order: 'Room order',
      };
      return map[type] || type || '—';
    },
  },
  created() {
    this.GetOrder();
    this.$store.dispatch("sitesetting/GetSettings");
  },
  computed: {
    ...mapState("sitesetting", ["setting"]),
    orderTypeLabel() {
      return this.orderTypeLabelFrom(this.Order && this.Order.order_type);
    },
    foodSubtotal() {
      const total = parseFloat(this.Order.total_amount) || 0;
      const ingredients = parseFloat(this.Order.ingredient_amount) || 0;
      return total - ingredients;
    },
    service_charge() {
      return this.setting ? this.setting.service_charge : 0;
    },
    payableAmount() {
      let ServiceCharge = 0;
      if (this.Order.order_type != "take_away") {
        ServiceCharge = (
          (this.Order.total_amount * this.service_charge) /
          100
        ).toFixed(0);
      }
      let TotalDiscount = 0;
      let ServiceDiscount = 0;

      if (this.istotaldiscount) {
        TotalDiscount = this.total_discount;
      }
      if (this.isservicecharge) {
        ServiceDiscount = this.service_discount;
      }
      return (
        parseFloat(this.Order.total_amount) +
        (parseFloat(ServiceCharge) - parseFloat(TotalDiscount) - parseFloat(ServiceDiscount))
      );
    },
  },

  filters: {
    price: function(value) {
      return value.toFixed(2);
    },
  },
};
</script>
<style scoped>
.checkout-page {
  min-height: 100vh;
  text-align: left;
  box-sizing: border-box;
}

.checkout-page__body {
  min-height: calc(100vh - var(--header-page-offset, 68px));
  box-sizing: border-box;
}

.checkout-page__toolbar {
  max-width: 1140px;
  margin: 0 auto;
  padding: 12px 15px 0;
}

.checkout-page__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.checkout-page__back:hover {
  background: var(--brand-primary-muted, rgba(81, 45, 130, 0.08));
  border-color: var(--brand-primary-border, rgba(81, 45, 130, 0.22));
}

.checkout-page__back i {
  font-size: 13px;
  line-height: 1;
}

.checkout-page__container {
  min-height: 0;
}

.checkout-main {
  padding: 12px 16px 20px;
}

.checkout-title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
}

.checkout-divider {
  margin: 12px 0;
  border: 0;
  border-top: 1px solid #e2e8f0;
}

.checkout-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
  margin: 0;
}

.checkout-meta__pair {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 8px;
  align-items: baseline;
  margin: 0;
}

.checkout-meta__pair--full {
  grid-column: 1 / -1;
}

.checkout-meta dt {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
}

.checkout-meta dd {
  margin: 0;
  font-size: 13px;
  color: #1e293b;
}

.checkout-meta__type {
  font-weight: 700;
  color: #c53a2a;
}

.checkout-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.checkout-table th,
.checkout-table td {
  border: 1px solid #cbd5e1;
  padding: 6px 8px;
  vertical-align: top;
}

.checkout-table th {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  background: #f8fafc;
  color: #334155;
}

.checkout-table__item {
  text-align: left;
  min-width: 120px;
}

.checkout-table__dish-name {
  font-weight: 600;
}

.checkout-table__ingredients {
  margin: 4px 0 0;
  padding-left: 16px;
  list-style: none;
  font-size: 11px;
  color: #64748b;
}

.checkout-totals {
  max-width: 320px;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.checkout-totals__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  font-size: 12px;
}

.checkout-totals__row--grand {
  font-size: 14px;
  font-weight: 700;
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
}

.checkout-totals__label {
  font-weight: 600;
  color: #475569;
  text-align: left;
}

.checkout-totals__value {
  font-weight: 700;
  color: #0f172a;
  text-align: right;
  white-space: nowrap;
}

.checkout-complete-btn {
  color: #fff !important;
  text-align: center;
}

.checkout-footnote {
  margin: 8px 0 0;
  font-size: 12px;
  color: #64748b;
  text-align: center;
}

.row {
  margin-right: -15px;
  margin-left: -15px;
}
.width-100perc {
  width: 100% !important;
}
.modal-body input[type="text"] {
  margin-bottom: 5px;
}
input[type="text"],
input[type="password"],
textarea,
input[type="tel"],
input[type="email"],
input[type="number"] {
  padding: 7px;
  border: 1px #e5e5e5 solid;
  margin-top: 2px;
  border-radius: 3px;
  /* border-bottom: #e5e5e5 2px solid; */
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}

div {
  text-align: left;
}
input {
  width: auto;
  border: auto;
}
.row {
  margin: 0px;
}
/* Check out bill modal */
.checkout-bill {
  padding: 4px 16px 12px;
  font-size: 14px;
  color: #1e293b;
}

.checkout-bill__card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  overflow: hidden;
}

.checkout-bill__card--nested {
  margin-top: 10px;
  padding: 12px;
  background: #fff;
}

.checkout-bill__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #e2e8f0;
}

.checkout-bill__row:last-child {
  border-bottom: none;
}

.checkout-bill__row--with-action {
  flex-wrap: wrap;
}

.checkout-bill__row-main {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.checkout-bill__label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.checkout-bill__label--block {
  display: block;
  margin: 0 0 6px;
}

.checkout-bill__value {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  text-align: right;
  white-space: nowrap;
}

.checkout-bill__toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
}

.checkout-bill__toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--brand-primary);
}

.checkout-bill__fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 14px 12px;
  border-bottom: 1px solid #e2e8f0;
}

.checkout-bill__section {
  margin-top: 14px;
}

.checkout-bill__input,
.checkout-bill__select {
  width: 100%;
  height: 40px;
  margin: 0 0 10px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: #fff;
  box-sizing: border-box;
}

.checkout-bill__input:focus,
.checkout-bill__select:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 2px var(--brand-primary-fade-20, rgba(81, 45, 130, 0.12));
}

.checkout-bill__payable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 14px;
  border-radius: 10px;
  background: var(--brand-primary-muted, rgba(81, 45, 130, 0.08));
  border: 1px solid var(--brand-primary-border, rgba(81, 45, 130, 0.2));
}

.checkout-bill__payable-label {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.checkout-bill__payable-value {
  font-size: 20px;
  font-weight: 800;
  color: var(--brand-primary-dark, #3f2366);
}

.checkout-bill__suspend-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
}

.checkout-bill__suspend-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--brand-primary);
}

.checkout-bill__required {
  color: #dc2626;
}

.checkout-bill__submit {
  width: 100%;
  height: 44px;
  margin-top: 16px;
  border: none;
  border-radius: 10px;
  background: var(--brand-primary);
  color: #fff !important;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.checkout-bill__submit:hover:not(:disabled) {
  background: var(--brand-primary-hover);
}

.checkout-bill__submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
